'use client';

function createVarsResolver(resolver) {
  return resolver;
}

export { createVarsResolver };